/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Priced_YesInputs */

const id_tld_pricing_priced_yes = /** @type {(inputs: Tld_Pricing_Priced_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah ada harga`)
};

const en_tld_pricing_priced_yes = /** @type {(inputs: Tld_Pricing_Priced_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priced`)
};

/**
* | output |
* | --- |
* | "Priced" |
*
* @param {Tld_Pricing_Priced_YesInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_priced_yes = /** @type {((inputs?: Tld_Pricing_Priced_YesInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Priced_YesInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_priced_yes(inputs)
	return id_tld_pricing_priced_yes(inputs)
});